// extracted by mini-css-extract-plugin
module.exports = {"menu":"HamburgerMenu_menu___j33L"};